module.exports = __webpack_public_path__ + "img/5.6fe909d6.png";